import React, {useLayoutEffect} from "react";
import { useIntl } from "react-intl";
import { useSelector} from "react-redux";

import Card from "../../UI/Card/Card";
import Section from "../../UI/Others/Section";
import NoteCard from "../../UI/Card/NoteCard";
import Headline from "../../Headline/Headline";
//import EmptyState from "../../UI/State/EmptyState";

import ExtLinkButton from "../../UI/Button/ExternalLinkButton";
import LinkButton from "../../UI/Button/LinkButton";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faBook, faUsers, faCommentDots,faArrowRight, faComments, faPhone, faMicrophone, faImages, faUserCircle, faVideo, faPaperPlane} from "@fortawesome/free-solid-svg-icons";
//import { faNewspaper} from "@fortawesome/free-regular-svg-icons";
import { faGithub, faJs } from "@fortawesome/free-brands-svg-icons";

const Web = () => {

    const intl = useIntl();
    const version = useSelector((state) => state.documentation.filter);

    const title = intl.messages.webTitle;
    const subtitle = intl.messages.webMessage;
    const getting_started = "doc/sdk/web/"+version+"/guides/Getting_Started";
        
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    function SDKCard(props) {
        return (
            <div className="d-flex col-lg-6">
                <NoteCard title={props.title} isBeta={props.isBeta} icon={props.icon} colorIcon="pink">
                    {props.children}
                </NoteCard>                
            </div>
        );
    }

    let cardAction = <div>
        <LinkButton className="btn-blue mb-2"
            to={getting_started}
            label={intl.messages.sdkStarted}
            icon={faBook}
        />
        <ExtLinkButton className="btn-green ml-2 mb-2"
            link="https://www.npmjs.com/package/rainbow-web-sdk"
            label="SDK"
            icon={faDownload}
        />                               
                                        
        <ExtLinkButton className="btn-orange ml-2 mb-2"
            link="https://github.com/Rainbow-CPaaS"
            label={intl.messages.sdkStarterKit}
            icon={faGithub}
        />
    </div>

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <div className="row">
                <div className="col-lg-6 d-flex">
                    <Card title={intl.messages.webCardTitle1} action={cardAction}>
                        <div className="card-text">{intl.messages.webCardTxt1} <br/><br/></div>
                    </Card>                   
                </div>

                <div className="col-lg-6 d-flex">
                    <Card title={intl.messages.webCardTitle2}>
                        <div className="card-text">{intl.formatMessage({id:"webCardTxt2"}, { b: chunks => <b>{chunks}</b>})} <br/><br/>
                            <div className="row">
                                <div className="col-6">
                                    <ul className="list-unstyled ">
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />{intl.messages.webListItem1}</li>
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />{intl.messages.webListItem2}</li>
                                    </ul>
                                </div>
                                <div className="col-6">
                                    <ul className="list-unstyled">
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />{intl.messages.webListItem3}</li>
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />{intl.messages.webListItem4}</li>
                                    </ul>
                                </div>
                            </div>    
                        </div>                        
                    </Card>
                    {/* <Card extended={true}
                        title="RAINBOW Web SDK Channel" 
                        subtitle="[version] - date" 
                        footer="Last updated xxx"
                    >
                    <div className="card-text"><EmptyState icon={faNewspaper} desc="nimia in peiores haeserat plagas" /></div>
                    </Card>                    */}
                </div>
            </div>

            <div className="row">
                <div className="d-flex col-lg-6">
                    <Card title={intl.messages.webCardTitle3}>
                        <div className="card-text">{intl.messages.webCardTxt3}</div>
                    </Card>
                </div>
                <div className="d-flex col-lg-6">
                    <Card title={intl.messages.webCardTitle4}>
                        <div className="card-text">{intl.formatMessage({id:"webCardTxt4"}, { b: chunks => <b>{chunks}</b>})}</div>
                    </Card>
                </div>
            </div>

            <Section 
                title={intl.messages.webGlanceTitle} 
                message={intl.messages.webGlanceMessage} 
                className="bg-pink"
            />
            
            <div className="row">
                <SDKCard title={intl.messages.webGlanceSubTitle1} icon={faJs}>{intl.messages.webGlanceTxt1}</SDKCard>
                <SDKCard title={intl.messages.webGlanceSubTitle2} icon={faUsers}>{intl.messages.webGlanceTxt2}</SDKCard>  
            </div>

            <div className="row">
                <SDKCard title={intl.messages.webGlanceSubTitle3} icon={faCommentDots}>{intl.messages.webGlanceTxt3}</SDKCard> 
                <SDKCard title={intl.messages.webGlanceSubTitle4} icon={faComments}>{intl.formatMessage({id:"webGlanceTxt4"}, { b: chunks => <b>{chunks}</b>})}</SDKCard>    
            </div>

            <div className="row">
                <SDKCard title={intl.messages.webGlanceSubTitle5} icon={faMicrophone}>{intl.messages.webGlanceTxt5}</SDKCard>
                <SDKCard title={intl.messages.webGlanceSubTitle6} icon={faVideo}>{intl.messages.webGlanceTxt6}</SDKCard>   
            </div>

            <div className="row">
                <SDKCard title={intl.messages.webGlanceSubTitle7} icon={faImages}>{intl.messages.webGlanceTxt7}</SDKCard>
                <SDKCard title={intl.messages.webGlanceSubTitle8} icon={faUserCircle}>{intl.messages.webGlanceTxt8}</SDKCard>
            </div>

            <div className="row">
                <SDKCard title={intl.messages.webGlanceSubTitle9} icon={faPhone}>{intl.messages.webGlanceTxt9}</SDKCard> 
                <SDKCard title={intl.messages.webGlanceSubTitle10} isBeta={true} icon={faPaperPlane}>{intl.messages.webGlanceTxt10}</SDKCard>   
            </div>
            
        </div>
    );
}

export default Web;